export const formatReminderInterval = (days) => {
  if (days === null || days === undefined) {
    return "Not available";
  }

  const interval = Number(days);

  if (interval === 0) {
    return "No Reminders";
  }

  return `Every ${interval} ${interval === 1 ? "day" : "days"}`;
};
